import { createContext, useContext } from "react";
import type { DiffLookup } from "@archlang/engine";

export const DiffContext = createContext<DiffLookup | null>(null);

export function useDiffLookup(): DiffLookup | null {
  return useContext(DiffContext);
}
